import React, { useEffect, useState } from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import Header from './components/Header'
import Footer from './components/Footer'
import Loading from './components/Loading'
import Error from './components/Error'
import { Specs } from './pages/Specs'
import { Condition } from './pages/Condition'
import { Personal } from './pages/Personal'
import { Offer } from './pages/Offer'
import { SET_APP } from './features/app/actionTypes'
import { SET_DEALER } from './features/dealer/actionTypes'
import { Routes, baseName } from './types.d'
import SendEvent from './analytics'

const App: React.FC = () => {
  const dispatch = useDispatch();
  const [hasSetDealer, setHasSetDealer] = useState(false);

  useEffect(() => {
    if (!hasSetDealer){
      setHasSetDealer(true);
      dispatch({type: SET_DEALER, payload: {
        dealerID: (window as any).StoreWebsiteInfo.DealerID,
        stockDealerID: (window as any).StoreWebsiteInfo.StockDealerID, 
        dealerName: (window as any).StoreWebsiteInfo.DealerName,
        locationName: (window as any).StoreWebsiteInfo.LocationName
      }});
    }
  });

  return (
    <BrowserRouter basename={baseName}>
      <div className="i-wrapper">
        <Header />
        <main className="i-main">
          <Switch>     
            <Route path={Routes.Specs} component={Specs} />
            <Route path={Routes.Condition} component={Condition} />
            <Route path={Routes.Personal} component={Personal} />
            <Route path={Routes.Offer} component={Offer} />
            <Route>
              <Redirect to={Routes.Specs} />
            </Route>
          </Switch>
        </main>
        <Footer />
        <Loading />
        <Error />
      </div>
    </BrowserRouter>
  )
}

export default App
